import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { LocationStoreService } from 'src/app/stores/location-store/location-store.service';
import { environment } from 'src/environments/environment';
import { ILocation } from '../location/location.service';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  public isLoading$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  // public locations$: BehaviorSubject<any> = new BehaviorSubject([]);
  // public currLocation$: BehaviorSubject<ILocation> = new BehaviorSubject({});
  public allVisibleMarkers$ = new BehaviorSubject({});
  public allDefectCounts$: BehaviorSubject<ILocation> = new BehaviorSubject({});
  public sticky$: BehaviorSubject<string[]> = new BehaviorSubject([]);
  public dataTable$: BehaviorSubject<any> = new BehaviorSubject({});
  // public annotations$: BehaviorSubject<any> = new BehaviorSubject([]);
  // public galleryImages$: BehaviorSubject<any> = new BehaviorSubject([]);
  // public galleryImagesCurrentIdx$: BehaviorSubject<any> = new BehaviorSubject(0);
  public defectCount$: BehaviorSubject<any> = new BehaviorSubject({});
  // public genericTypes$: BehaviorSubject<any> = new BehaviorSubject([]);
  public featureImages$: BehaviorSubject<any> = new BehaviorSubject([]);
  // public cardMediumExpanded$: BehaviorSubject<any> = new BehaviorSubject(false);
  // public genericTypes = []
  // public severityList = []
  // public defectTypeList = []
  public locationComponentList = []
  // public allLocations = {}
  public allDefectCounts = {}

  public localStorageSub$: BehaviorSubject<any> = new BehaviorSubject({});

  API_SERVER: string = environment.baseApiUrl;

  constructor(private httpClient: HttpClient, private locationStore: LocationStoreService) { }

  // get getLocations() {
  //   return this.locations$.getValue();
  // }

  // set setLocations(data) {
  //   this.locations$.next(data);
  // }

  // set setGenericTypes(data) {
  //   this.genericTypes$.next(data) 
  //   this.genericTypes = data
  //   this.severityList = data.filter(({category}) => category === 'severity')
  //   this.defectTypeList = data.filter(({category}) => category === 'annotation')
  // }

  // set setAnnotations(data) {
  //   this.annotations$.next(data)
  // }

  // set setGalleryImages(data) {
  //   this.galleryImages$.next(data)
  // }

  // set pushGenericTypes(data) {
  //   this.genericTypes$.next([...this.locationStore.locations$.getValue(), data])
  //   this.genericTypes.push(data)
  // }

  // set popGenericTypes(id) {
  //   const oldData = this.genericTypes$.getValue()
  //   const newData = oldData.filter(i => i.id !== id)
  //   this.genericTypes$.next(newData)
  //   this.genericTypes = newData
  // }

  // set setCurrentGalleryImages(data) {
  //   this.galleryImagesCurrentIdx$.next(data)
  // }

  // get currentLocation() {
  //   return this.currLocation$.value;
  // }

  // set setCurrentLocation(data) {
  //   this.currLocation$.next(data);
  // }

  // set pushLocations(data) {
  //   this.locations$.next([...this.locations$.getValue(), data]);
  // }

  // getLocationById(id: string = this.currentLocation.id): Observable<any> {
  //   return this.httpClient.get(`${this.API_SERVER}/location/${id}`);
  // }

  // getData(zoomLevel?, params?): Observable<any> {
  //   return new Observable((observer) => {
  //     observer.next(data);
  //     this.locations$.next(data);
  //   });
  // }

  // createAnnotation(data): Observable<any> {
  //   return this.httpClient.post(`${this.API_SERVER}/annotation`, data);
  // }

  // updateAnnotation(id: string, data): Observable<any> {
  //   return this.httpClient.put(`${this.API_SERVER}/annotation/${id}`, data);
  // }

  // getAnnotationByID(id: string): Observable<any> {
  //   return this.httpClient.get(`${this.API_SERVER}/annotation`);
  // }

  // get getDataTable() {
  //   return this.dataTable$;
  // }

  // getTable(): Observable<any> {
  //   return new Observable((observer) => {
  //     observer.next(dataTable);
  //     this.dataTable$.next(dataTable);
  //   });
  // }

  // getGenericType(category: GTypeCat, id?, column_name?, raw?) {
  //   const gTypeByCat = this._reformatGenericTypeByCat(this.genericTypes, !raw)[category]

  //   if (id && column_name) return gTypeByCat[id][column_name]
  //   if (id) return gTypeByCat[id]

  //   return gTypeByCat
  // }

  // _reformatGenericTypeByCat(data, indexedWithId?) {
  //   const newData = []
  //   data.forEach((elem) => {
  //     if (newData[elem.category] === undefined) {
  //       newData[elem.category] = [];
  //     }
  //     if (indexedWithId)
  //       newData[elem.category][elem.id] = { ...elem };
  //     else
  //       newData[elem.category].push(elem)
  //   })
  //   return newData
  // }

  getReferenceImagesFromPointCloud (location, points:any[]) :Observable<any> {
    if (points.length == 1) {
      let assetName = location.name;
      if (location.name.indexOf("Wilhelm") >= 0) {
        assetName = "WilhelmBuschSchuleNew";
      }
      
      // const singlePointAPI = `https://us-central1-latlongmapping-83f20.cloudfunctions.net/threeDtoImg?x=${points[0].x}&y=${points[0].y}&z=${points[0].z}`;
      // https://us-central1-latlongmapping-83f20.cloudfunctions.net/threeDtoImgArr?assetName=貯蔵庫16号棟&arrPts=[{"x":"255427.89961876321","y":"3967885.4202803625","z":"769.3878291446616"},{"x":"255427.89961876321","y":"3967885.4202803625","z":"769.3878291446616"}]
      const singlePointAPI = `https://us-central1-latlongmapping-83f20.cloudfunctions.net/threeDtoImgArr?assetName=${assetName}&arrPts=${JSON.stringify(points)}`;
      
      
      return this.httpClient.get(singlePointAPI);
    } else {
      // handle more than one points with these interface
      // https://us-central1-latlongmapping-83f20.cloudfunctions.net/threeDtoImgArr?arrPts=[{"x":"255427.89961876321","y":"3967885.4202803625","z":"769.3878291446616"},{"x":"255427.89961876321","y":"3967885.4202803625","z":"769.3878291446616"}]
    }
  }

  clearDataService() {
    // this.isLoading$ = new BehaviorSubject(false);
    // this.locations$ = new BehaviorSubject([]);
    // this.currLocation$ = new BehaviorSubject({});
    this.sticky$ = new BehaviorSubject([]);
    this.dataTable$ = new BehaviorSubject({});
    // this.annotations$ = new BehaviorSubject({});
    this.defectCount$ = new BehaviorSubject({});
    // this.genericTypes$ = new BehaviorSubject([]);
  }

  setLocalStorage(key, data) {
    localStorage.setItem(key, data)
    this.localStorageSub$.next({key, data})
  }
}

export type GTypeCat = 'annotation' | 'component' | 'severity';